export default __webpack_public_path__ + "static/media/Blacksulphur Slippers.e9d858a4.jpg";